import { fromColorPathToColor } from '@weenat/theme'
import Icons from 'app/src/kit/Icons'
import { useId } from 'react'

interface LeafIntensityProps {
  /** Leaf wetness intensity, expressed on a 0–10 scale. */
  intensity: number
}

/**
 * Visual representation of a leaf wetness intensity.
 *
 * Renders a leaf icon filled from the bottom up with a vertical gradient, the
 * filled height being proportional to the given intensity (on a 0–10 scale): an
 * intensity of `0` leaves the icon empty (grey) while `10` fills it entirely
 * with the leaf wetness colour.
 */
const LeafIntensity: FC<LeafIntensityProps> = ({ intensity }) => {
  // Unique per instance so multiple leaves can be rendered on the same page
  // without their gradient definitions colliding.
  const gradientId = useId()
  const offset = `${100 - intensity * 10}%`

  return (
    <>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id={gradientId} gradientTransform='rotate(90)'>
            <stop offset={offset} stopColor={fromColorPathToColor('grayscale.200')} />
            <stop offset={offset} stopColor={fromColorPathToColor('metrics.LW_D.500')} />
          </linearGradient>
        </defs>
      </svg>
      <Icons.Leaf $size='2xl' $color={`url(#${gradientId})`} />
    </>
  )
}

export default LeafIntensity
